import { fullName } from '../utils/blacklistService';

const riskColor = (lvl) => {
  const l = String(lvl || '').toLowerCase();
  if (l === 'critical') return '#7f1d1d';
  if (l === 'high') return '#dc2626';
  if (l === 'medium') return '#f59e0b';
  return '#64748b';
};

/**
 * ⚠️ Blacklisted-customer warning shown before a contract is created.
 * Props: matches [{record, reasons}], onCancel(), onContinue()
 */
export default function BlacklistWarningModal({ matches = [], onCancel, onContinue }) {
  if (!matches.length) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 100000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', fontFamily: 'system-ui,sans-serif' }}>
      <div style={{ background: 'white', borderRadius: '18px', width: '100%', maxWidth: '640px', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ background: 'linear-gradient(135deg,#dc2626,#7f1d1d)', color: 'white', padding: '18px 22px', borderRadius: '18px 18px 0 0' }}>
          <div style={{ fontSize: '20px', fontWeight: 900 }}>⚠️ CLIENT SUR LISTE NOIRE DÉTECTÉ</div>
          <div style={{ fontSize: '13px', opacity: 0.9, marginTop: '2px' }}>
            {matches.length} correspondance(s) trouvée(s) dans la liste noire globale.
          </div>
        </div>

        <div style={{ padding: '18px 22px' }}>
          {matches.map(({ record: r, reasons }, i) => (
            <div key={i} style={{ border: `2px solid ${riskColor(r.riskLevel)}`, borderRadius: '14px', padding: '14px', marginBottom: '14px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                <div style={{ fontSize: '17px', fontWeight: 900, color: '#111' }}>👤 {fullName(r) || '—'}</div>
                <span style={{ background: riskColor(r.riskLevel), color: 'white', padding: '3px 12px', borderRadius: '999px', fontSize: '12px', fontWeight: 800 }}>
                  {r.riskLevel || 'Medium'}
                </span>
              </div>
              <div style={{ fontSize: '12px', color: '#b91c1c', fontWeight: 700, margin: '6px 0' }}>
                🔎 Correspondance sur : {reasons.join(', ')}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 16px', fontSize: '13px', color: '#334155' }}>
                <div><b>Prénom :</b> {r.firstName || '—'}</div>
                <div><b>Nom :</b> {r.lastName || '—'}</div>
                <div><b>C.N.I.E :</b> {r.cnie || '—'}</div>
                <div><b>Ville :</b> {r.city || '—'}</div>
                <div style={{ gridColumn: '1 / -1' }}><b>Adresse :</b> {r.address || '—'}</div>
                <div style={{ gridColumn: '1 / -1' }}><b>Motif :</b> {r.reason || '—'}</div>
                {r.incident && <div style={{ gridColumn: '1 / -1' }}><b>Incident :</b> {r.incident}</div>}
                <div><b>Agence :</b> {r.sourceAgency || '—'}</div>
                <div><b>Montant dû :</b> {r.outstanding ? `${r.outstanding} ${r.currency || 'DH'}` : '—'}</div>
              </div>
              {Array.isArray(r.attachments) && r.attachments.length > 0 && (
                <div style={{ marginTop: '8px', fontSize: '12px' }}>
                  <b>📎 Documents :</b>{' '}
                  {r.attachments.map((a, j) => (
                    <a key={j} href={a.url} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', marginRight: '8px', textDecoration: 'underline' }}>
                      {a.name || `Fichier ${j + 1}`}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '4px' }}>
            <button onClick={onCancel}
              style={{ flex: '1 1 220px', padding: '13px', borderRadius: '12px', border: 'none', background: '#16a34a', color: 'white', fontWeight: 800, fontSize: '14px', cursor: 'pointer' }}>
              ✅ Annuler le contrat (Recommandé)
            </button>
            <button
              onClick={() => {
                if (confirm('⚠️ Vous continuez avec un client BLACKLISTÉ.\n\nVous acceptez l\'ENTIÈRE RESPONSABILITÉ. Cette action sera enregistrée de façon permanente dans le journal d\'audit.\n\nConfirmer ?')) {
                  onContinue();
                }
              }}
              style={{ flex: '1 1 220px', padding: '13px', borderRadius: '12px', border: '2px solid #dc2626', background: 'white', color: '#dc2626', fontWeight: 800, fontSize: '14px', cursor: 'pointer' }}>
              ⚠️ Continuer quand même (Responsabilité totale)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
